(() => {
  const root = document.documentElement;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let observer;

  const getRevealElements = (scope) => {
    const elements = [];

    if (scope instanceof Element && scope.matches('.mp-reveal')) {
      elements.push(scope);
    }

    if (scope.querySelectorAll) {
      elements.push(...scope.querySelectorAll('.mp-reveal'));
    }

    return elements;
  };

  const showImmediately = (elements) => {
    elements.forEach((element) => element.classList.add('is-visible'));
  };

  const observe = (scope = document) => {
    const elements = getRevealElements(scope).filter((element) => !element.classList.contains('is-visible'));
    if (!elements.length) return;

    if (reduceMotion.matches || !('IntersectionObserver' in window) || root.classList.contains('shopify-design-mode')) {
      showImmediately(elements);
      return;
    }

    if (!observer) {
      observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
      );
    }

    elements.forEach((element) => {
      const rect = element.getBoundingClientRect();
      const isInitiallyVisible = rect.top < window.innerHeight * 0.92 && rect.bottom > 0;

      if (isInitiallyVisible) {
        element.classList.add('is-visible');
      } else {
        observer.observe(element);
      }
    });
  };

  const start = () => {
    const elements = getRevealElements(document);
    if (!elements.length) return;

    if (!reduceMotion.matches && 'IntersectionObserver' in window && !root.classList.contains('shopify-design-mode')) {
      root.classList.add('mp-motion-ready');
    }

    observe(document);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', (event) => observe(event.target));
  document.addEventListener('shopify:block:select', (event) => showImmediately(getRevealElements(event.target)));

  reduceMotion.addEventListener?.('change', (event) => {
    if (!event.matches) return;
    root.classList.remove('mp-motion-ready');
    showImmediately(getRevealElements(document));
    observer?.disconnect();
    observer = undefined;
  });
})();
